import { ReactNode } from 'react';
import cn from 'classnames';

import type { IconSize, IIconProps } from '../types';
import styles from './baseIcon.module.scss';

const DEFAULT_SIZE = 16;

const SIZE_CLASS: Record<IconSize, string> = {
  10: styles.size10,
  12: styles.size12,
  14: styles.size14,
  16: styles.size16,
  18: styles.size18,
  20: styles.size20,
};

interface IBaseIconProps extends IIconProps {
  /** The shapes this icon is made of. Supplied by the generated icon component. */
  children: ReactNode,
}

const BaseIcon = ({
  children,
  className,
  size,
  role,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden,
  ...props
}: IBaseIconProps) => {
  const isMeaningful = Boolean(ariaLabel) || Boolean(role);

  return (
    <svg
      focusable="false"
      width={ DEFAULT_SIZE }
      height={ DEFAULT_SIZE }
      { ...props }
      role={ role ?? (ariaLabel ? 'img' : undefined) }
      aria-label={ ariaLabel }
      aria-hidden={ ariaHidden ?? (isMeaningful ? undefined : true) }
      className={ cn(styles.i, className, size && SIZE_CLASS[size]) }
    >
      { children }
    </svg>
  );
};

export default BaseIcon;
